import { cx, styled } from "simplydo/react/styled";

import { StyledAccordionContent } from "./Accordion.styles";
import type { AccordionContentProps } from "./Accordion.types";
import { useAccordionContext } from "./AccordionContext";

const AccordionContentComponent = (props: AccordionContentProps) => {
  const {
    active: activeProp,
    children,
    className,
    content,
    index,
    style,
    onClick,
  } = props;

  const ctx = useAccordionContext();
  const active =
    activeProp !== undefined
      ? activeProp
      : (ctx?.isIndexActive(index) ?? false);

  const classes = cx(active && "is-active", className);

  return (
    <StyledAccordionContent className={classes} style={style} onClick={onClick}>
      {children != null ? children : content}
    </StyledAccordionContent>
  );
};

export const AccordionContent = styled(AccordionContentComponent)``;
